export const deriveTabs = (
  tabs: string[],
  setCurrentTab: (index: number) => void,
  currentTab: number,
  onTabChange?: (tab: string, index: number) => void,
) => {
  return tabs.map((tab: string, index: number) => ({
    id: tab,
    onClick: () => {
      setCurrentTab(index)
      onTabChange?.(tab, index)
    },
    active: currentTab === index,
  }))
}
